import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { PropertyModel } from "../_model/property/property.model";
import { camelToPascal, exists } from "../_helper/util.helper";
import { MediaModel } from "../_model/media/media.model";
import { UserService } from "./user.service";
import { NotificationService } from "./notification.service";

@Injectable({
  providedIn: 'root'
})
export class VideoMarketingService {

  private url: string = environment.videoMarketingUrl;
  private api: string = environment.videoMarketingApi;

  private hasVideoMarketing: boolean = !!this.url && !!this.api;
  private token: string = null;

  constructor(
    private http: HttpClient,
    private userService: UserService,
    private notificationService: NotificationService
  ) {
    this.loadToken();
  }

  private async loadToken() {
    return this.userService.getTokenAsync().then(_token => {
      this.token = _token;
    });
  }
  public showVideoMarketing(): boolean {
    return this.hasVideoMarketing;
  }

  public async toVideoMarketing(listing: PropertyModel, media: MediaModel[]) {

    let isLessThan2MinutesOld = Date.now() - new Date(listing.ModificationTimestamp).getTime() < 2 * 60 * 1000;

    //TEMP: always forcing POST for now
    if (true || isLessThan2MinutesOld) {
      if (!this.token) await this.loadToken();
      // < 2m since modified, POST the listing data off and receive the url
      let videoListing = new VideoMarketingListing(listing, media);
      await this.http.post(this.api + 'api/new-listing?token=' + this.token, videoListing, { responseType: 'text' }).toPromise().then(url => {
        //and awaaaaay we go
        window.location.href = url;
      }).catch(err => {
        environment.error(err);
        //TEMP: just gonna show an error for now
        this.notificationService.error('There was an issue connecting to Supreme Video.');
        //well... fallback to the link i guess
        // window.location.href = this.buildFrontendUrl(listing.ListingKey);
      });
    } else {
      // > 2m since modified, just go to the frontend url
      window.location.href = this.buildFrontendUrl(listing.ListingKey);
    }
  }

  private buildFrontendUrl(listingKey: string): string {
    return this.url + 'videos/new?type=LISTING&key=' + listingKey;
  }
}

class VideoMarketingListing {

  systemKey: string = null;
  listingKey: string = null;
  listAgentKey: string = null;
  listOfficeKey: string = null;
  coListAgentKey: string = null;
  coListOfficeKey: string = null;
  coListAgent3Key: string = null;
  coListOfficeKey3: string = null;
  coListAgent4Key: string = null;
  coListOfficeKey4: string = null;
  streetNumber: string = null;
  streetDirPrefix: string = null;
  streetName: string = null;
  streetSuffix: string = null;
  streetDirSuffix: string = null;
  unitNumber: string = null;
  city: string = null;
  stateOrProvince: string = null;
  postalCode: string = null;
  propertyType: string = null;
  propertySubType: string = null;
  transactionType: string = null;
  listPrice: number = null;
  taxAnnualAmount: number = null;
  bedroomsTotal: number = null;
  bathroomsTotalInteger: number = null;
  publicRemarks: string = null;
  aiPublicRemarks: string[] = [];
  thumbnailUrl: string = null;
  contractStatus: string = null;
  standardStatus: string = null;
  photos: VideoMarketingMedia[] = [];

  constructor(listing: PropertyModel, media: MediaModel[]) {
    //listing
    for (let key in this) {
      let camelKey = ''+key;
      let pascalKey = camelToPascal(camelKey);
      if (exists(listing[camelKey]))
        this[camelKey] = listing[camelKey];
      else if (exists(listing[pascalKey]))
        this[camelKey] = listing[pascalKey];
    }
    //media
    if (media?.length) {
      this.photos = media.map(m => new VideoMarketingMedia(m));
      this.thumbnailUrl = media[0].getPhotoUrl("Thumbnail") || media[0].mediaUrl;
    }
    //system key
    this.systemKey = 'amp/' + listing.CustomerName;
  }
}

class VideoMarketingMedia {

  mediaKey: string = null;
  resourceName: string = null;
  resourceRecordKey: string = null;
  imageSizeDescription: string = null;
  mediaCategory: string = null;
  mediaStatus: string = null;
  mediaType: string = null;
  mediaURL: string = null;
  order: number = null;

  constructor(media: MediaModel) {
    //media
    for (let key in this) {
      let camelKey = ''+key;
      if (exists(media[camelKey]))
        this[camelKey] = media[camelKey];
    }
    //url
    this.mediaURL = media.getPhotoUrl('Original') || media.mediaUrl;
  }
}
